import styled from 'styled-components';
import DEVICES from '../../common/styles/devices';
import { FONT_FAMILY } from '../../common/styles/fontStyles';
import COLORS from '../../common/styles/color-pallete';

export const AmazeBanner = styled.div`
  background-color: ${COLORS.black};
  margin-top: 60px;
  border-radius: 8px;
  padding: 7px 12px 0px;

  display: flex;
  align-items: center;

  button {
    padding: 0 !important;
  }
  .bannerImg {
    width: 164px;
    height: 228px;
  }
  .bannerImgMobile {
    display: none;
  }

  .bannerMsgContainer {
    color: ${COLORS.white};
    max-width: 442px;
    margin: 0px 0px 24px 48px;

    .bannerHeading {
      font-size: 28px;
      font-family: ${FONT_FAMILY.hellix.bold};
      line-height: 38px;
      margin-bottom: 8px;
    }
    .bannerMessage {
      font-size: 20px;
      font-family: ${FONT_FAMILY.hellix.bold};
      line-height: 24px;
      margin-bottom: 24px;
    }
    .bannerButton {
      cursor: pointer;
      background-color: ${COLORS.dividerBlue};
      border-radius: 4px;
      padding: 6px 16px;
      font-size: 16px;
      font-family: ${FONT_FAMILY.hellix.bold};
      line-height: 26px;
      border: none;
    }
  }

  @media ${DEVICES.mobileXL} {
    flex-direction: column;

    .bannerImg {
      display: none;
    }
    .bannerImgMobile {
      display: block;
      width: 212px;
      height: 141px;
      margin-top: 20px;
    }

    .bannerMsgContainer {
      max-width: 350px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      margin: 18px 0px 24px 0px;

      .bannerHeading {
        font-size: 18px;
        line-height: 26px;
      }
      .bannerMessage {
        font-size: 16px;
        line-height: 21px;
        text-align: center;
      }
    }
  }
`;
